import { useState } from "react";
import { User, PenTool, Calendar, Award, Lock } from "lucide-react";

// #region INTERFACES
export interface ProfileModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDarkMode?: boolean;
}
export interface ProfileDataProps {
  open: boolean;
}

type ProfileTab =
  | "general"
  | "availability"
  | "accreditations"
  | "password"
  | "signature";
// #endregion

export const useProfileData = ({ open }: ProfileDataProps) => {
  const tabs = [
    { id: "general" as ProfileTab, label: "General", icon: User },
    { id: "availability" as ProfileTab, label: "Availability", icon: Calendar },
    {
      id: "accreditations" as ProfileTab,
      label: "Accreditations & Skills",
      icon: Award,
    },
    {
      id: "signature" as ProfileTab,
      label: "Digital Signature",
      icon: PenTool,
    },
  ];

  // #region States
  const [activeTab, setActiveTab] = useState<ProfileTab>("general");
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteAction, setDeleteAction] = useState<() => void>(() => () => {});
  const [deleteMessage, setDeleteMessage] = useState(null);
  // #endregion

  // #region Return
  return {
    tabs,
    activeTab,
    setActiveTab,
    errorMessage,
    errorModalOpen,
    setErrorModalOpen,
    deleteModalOpen,
    setDeleteModalOpen,
    deleteMessage,
    deleteAction,
    setErrorMessage,
    setDeleteMessage,
    setDeleteAction,
  };
  // #endregion
};
